


















import { Component, Prop } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { ConsumptionSchedulingInfo, ConsumptionSchedulingInfos } from '@/dto';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import DataSource from 'devextreme/data/data_source';
import { ContextsState } from '@/store';
import { Table, TableOptions, getTableCaption } from '@/core/components/table';
import { Page } from '@/core/components/controls';
import {
    FetchServiceContract,
    CONTRACTS,
    EventsServiceContract,
    Events
    } from '@/core/contracts';
import { ConsumptionPerformancePageArgs } from './types';
import ConsumptionPerformanceTable from './ConsumptionPerformanceTable.vue';

@Component({
    components: {
        ConsumptionPerformanceTable,
        TableOptions,
    },
})
export default class ConsumptionPerformancePage extends Page {
    @Prop({ default: () => ({}) }) public args!: ConsumptionPerformancePageArgs;
    public table: Table | null = null;
    public tableKey: string = 'consumption-performance-control';

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;

    public setTable(table: Table): void {
        this.table = table;
    }

    public async mounted() {
        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public get dataSource(): DataSource {
        return new DataSource({
            load: this.load,
        });
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    private onProcessingFinished({ contextId }: any) {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.table!.refresh();
        }
    }

    private async load() {
        const url = `/contexts/${this.args!.contextId}/consumptions/${
            this.args!.packAlias
        }/scheduling-info`;
        const data = await this._fetchService!.get<ConsumptionSchedulingInfo>(url);
        return data;
    }
}
